import { TagNeedsReview } from "../api/models";
import Emails from "../components/Emails";

const EmailsToReview = () => {
    return (
        <Emails filterTag={TagNeedsReview}/>
    );
};
export default EmailsToReview;
